__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@portal/workspace";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@codat/analytics", "2.5.1", () => (Promise.all([__webpack_require__.e(6128), __webpack_require__.e(6297), __webpack_require__.e(9335)]).then(() => (() => (__webpack_require__(16128))))));
			register("@codat/client-cookie-manager", "4.1.0", () => (Promise.all([__webpack_require__.e(4686), __webpack_require__.e(9654), __webpack_require__.e(6297)]).then(() => (() => (__webpack_require__(59654))))));
			register("@portal/shared/config", "0.0.0", () => (() => (__webpack_require__(22617))), 1);
			register("@tanstack/react-query", "5.65.1", () => (Promise.all([__webpack_require__.e(194), __webpack_require__.e(6297), __webpack_require__.e(6070)]).then(() => (() => (__webpack_require__(30194))))));
			register("i18next", "25.8.13", () => (__webpack_require__.e(1652).then(() => (() => (__webpack_require__(11652))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(8143), __webpack_require__.e(6297)]).then(() => (() => (__webpack_require__(8143))))));
			register("react-i18next", "16.5.4", () => (Promise.all([__webpack_require__.e(3053), __webpack_require__.e(6297), __webpack_require__.e(2310)]).then(() => (() => (__webpack_require__(93053))))));
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(8274), __webpack_require__.e(6297), __webpack_require__.e(857)]).then(() => (() => (__webpack_require__(8274))))));
			register("react", "18.3.1", () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};